import { gql } from '@apollo/client';

export const GENERATE_IL_DISCLOSURE_FORMS = gql`
  mutation Flex_GenerateIlDisclosureForms($planId: Int!, $redirectUri: String) {
    generateIlDisclosureForms(planId: $planId, redirectUri: $redirectUri) {
      enqueued
      planId
    }
  }
`;
